/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Where a question stands, derived from its answer and publication.
 * @export
 */
export const EventQuestionStatus = {
    Open: 'open',
    Answered: 'answered',
    Published: 'published'
} as const;
export type EventQuestionStatus = typeof EventQuestionStatus[keyof typeof EventQuestionStatus];


export function instanceOfEventQuestionStatus(value: any): boolean {
    for (const key in EventQuestionStatus) {
        if (Object.prototype.hasOwnProperty.call(EventQuestionStatus, key)) {
            if (EventQuestionStatus[key as keyof typeof EventQuestionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EventQuestionStatusFromJSON(json: any): EventQuestionStatus {
    return EventQuestionStatusFromJSONTyped(json, false);
}

export function EventQuestionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventQuestionStatus {
    return json as EventQuestionStatus;
}

export function EventQuestionStatusToJSON(value?: EventQuestionStatus | null): any {
    return value as any;
}

export function EventQuestionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): EventQuestionStatus {
    return value as EventQuestionStatus;
}

